import { Component, Input, OnInit } from '@angular/core';
import {PostDO} from '../../common/data-objects/PostDO';

@Component({
  selector: 'app-song-thumbnail',
  templateUrl: './song-thumbnail.component.html',
  styleUrls: ['./song-thumbnail.component.scss']
})
export class SongThumbnailComponent implements OnInit {
  @Input() post: PostDO;

  constructor() { }

  ngOnInit(): void {
  }

  getImageUrl(post): string {
    return post.featuredImageSizes ? post.featuredImageSizes.medium : null;
  }

  get postLink(): string[] {
    return [this.post.slug];
  }
}
